const SELLER_TOUR_VERSION = 'v1'
export const SELLER_TOUR_PENDING_KEY =
  `pexify:seller-tour:pending:${SELLER_TOUR_VERSION}`

export type SellerTourSeenStatus = 'completed' | 'skipped'

export type SellerTourSeen = {
  status: SellerTourSeenStatus
  seenAt: string
}

function sessionStore(storage?: Storage): Storage | null {
  if (storage) return storage
  if (typeof window === 'undefined') return null
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

function localStore(storage?: Storage): Storage | null {
  if (storage) return storage
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export function sellerTourSeenKey(userId: string): string {
  return `pexify:seller-tour:${SELLER_TOUR_VERSION}:${userId}`
}

export function markSellerTourPending(storage?: Storage): void {
  try {
    sessionStore(storage)?.setItem(SELLER_TOUR_PENDING_KEY, '1')
  } catch {
    // Storage is best-effort; onboarding navigation must still continue.
  }
}

export function consumeSellerTourPending(storage?: Storage): boolean {
  try {
    const target = sessionStore(storage)
    if (target?.getItem(SELLER_TOUR_PENDING_KEY) !== '1') return false
    target.removeItem(SELLER_TOUR_PENDING_KEY)
    return true
  } catch {
    return false
  }
}

export function readSellerTourSeen(
  userId: string,
  storage?: Storage,
): SellerTourSeen | null {
  try {
    const raw = localStore(storage)?.getItem(sellerTourSeenKey(userId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<SellerTourSeen>
    if (
      (parsed.status !== 'completed' && parsed.status !== 'skipped') ||
      typeof parsed.seenAt !== 'string'
    ) {
      return null
    }
    return { status: parsed.status, seenAt: parsed.seenAt }
  } catch {
    return null
  }
}

export function writeSellerTourSeen(
  userId: string,
  status: SellerTourSeenStatus,
  storage?: Storage,
): void {
  try {
    localStore(storage)?.setItem(
      sellerTourSeenKey(userId),
      JSON.stringify({ status, seenAt: new Date().toISOString() }),
    )
  } catch {
    // A private/unavailable storage mode must not break the seller shell.
  }
}
